<ng-container *ngIf="showIcon">
  <div [bfx-input]="bfxInput" [ngClass]="inputDirective.classes" #input>
    <div class="bfx-input-label">
      <div [ngClass]="inputDirective.labelClasses">{{label}}<span *ngIf="required">*</span></div>
    </div>
    <div [ngClass]="inputDirective.innerClasses">
      <div [bfx-field-select]="bfxFieldSelect" [ngClass]="fieldDirective.classes">
        <ng-container *ngFor="let icon of startIconsClasses; index as i">
          <bfx-icon-button
            #ddBtn
            [parentSize]="size"
            [iconClass]="icon"
            [disabled]="disabled"
            *ngIf="dropdown"
            tabindex="-1"
            (pointerover)="onFieldPointerOver($event)"
            (pointerout)="onFieldPointerOut($event)"
            (action)="onFieldIconClick($event, 'start', i)"
          ></bfx-icon-button>
        </ng-container>
        <ng-container *ngTemplateOutlet="startTemplateRef"></ng-container>
        <input
          #inputfield
          [ngClass]="fieldDirective.inputClasses"
          type="search"
          autocomplete="off"
          [readonly]="!parseInput"
          [attr.id]="inputId"
          [attr.name]="name"
          [attr.placeholder]="placeholder"
          [attr.required]="required"
          [value]="inputFieldValue"
          [ngStyle]="inputStyle"
          [class]="inputStyleClass"
          [placeholder]="placeholder||''"
          [disabled]="disabled"
          (click)="onInputClick($event)"
          (focus)="onInputFocus($event)"
          (keydown)="onInputKeydown($event)"
          (blur)="onInputBlur($event)"
          (input)="onUserInput($event)"
          (pointerover)="onFieldPointerOver($event)"
          (pointerout)="onFieldPointerOut($event)"
        />
        <span *ngIf="fieldSuffix" class="bfx-field-suffix" [innerHtml]="fieldSuffix"></span>
        <ng-container *ngFor="let icon of endIconsClasses; index as i">
          <bfx-icon-button
            #ddBtn
            [parentSize]="size"
            [iconClass]="icon"
            [disabled]="disabled"
            tabindex="-1"
            (pointerover)="onFieldPointerOver($event)"
            (pointerout)="onFieldPointerOut($event)"
            (action)="onFieldIconClick($event, 'end', i)"
          ></bfx-icon-button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
<div
  #datepicker
  [class]="panelStyleClass"
  class="interface-control__bfx-calendar__datepicker ui-datepicker"
  [ngClass]="{'ui-state-disabled':disabled,'ui-datepicker-timeonly':timeOnly}"
  [ngStyle]="{'display': overlayVisible ? 'block' : 'none'}"
  (click)="onDatePickerClick($event)"
  (keydown)="onInputKeydown($event)"
  [@overlayState]="overlayVisible ? 'visible' : 'hidden'"
>
  <div class="interface-control__bfx-calendar__body__container">
    <div
      class="interface-control__bfx-calendar__datepicker__header"
      *ngIf="!timeOnly && (overlayVisible)"
    >
      <ng-content select="p-header"></ng-content>
      <bfx-icon-button
        size="sm"
        iconClass="icon_ion_chevron_left"
        (action)="prevMonth($event)"
        title="Previous Month"
      ></bfx-icon-button>
      <div class="interface-control__bfx-calendar__datepicker__title">
        <span class="bfx-datepicker-month" *ngIf="!monthNavigator"
          >{{locale.monthNames[currentMonth]}}</span
        >
        <select
          class="bfx-datepicker-month"
          *ngIf="monthNavigator"
          (change)="onMonthDropdownChange($event.target.value)"
        >
          <option
            [value]="i"
            *ngFor="let month of locale.monthNames;let i = index"
            [selected]="i == currentMonth"
          >
            {{month}}
          </option>
        </select>
        <select
          class="bfx-datepicker-year"
          *ngIf="yearNavigator"
          (change)="onYearDropdownChange($event.target.value)"
        >
          <option [value]="year" *ngFor="let year of yearOptions" [selected]="year == currentYear">
            {{year}}
          </option>
        </select>
        <span class="bfx-datepicker-year" *ngIf="!yearNavigator">{{currentYear}}</span>
      </div>
      <bfx-icon-button
        size="sm"
        iconClass="icon_ion_chevron_right"
        (action)="nextMonth($event)"
        title="Next Month"
      ></bfx-icon-button>
    </div>

    <table
      class="interface-control__bfx-calendar__datepicker__container"
      *ngIf="!timeOnly && overlayVisible"
    >
      <thead>
        <tr>
          <th
            scope="col"
            *ngFor="let weekDay of weekDays;let begin = first; let end = last"
            class="interface-control__bfx-calendar__datepicker__weekdays"
          >
            <span>{{weekDay}}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let week of dates" class="interface-control__bfx-calendar__datepicker__body">
          <td
            *ngFor="let date of week"
            [ngClass]="{
              'bfx-datepicker-other-month interface-control__bfx-calendar__state--disabled':date.otherMonth,
              'bfx-datepicker-current-day':isSelected(date),
              'bfx-datepicker-today':date.today,
            }"
          >
            <a
              #dateEl
              class="interface-control__bfx-calendar__state--default"
              href="#"
              *ngIf="date.otherMonth ? showOtherMonths : true"
              [ngClass]="{
                'interface-control__bfx-calendar__state--active':isSelected(date),
                'interface-control__bfx-calendar__state--disabled':!date.selectable,
                'interface-control__bfx-calendar__date': true,
              }"
              (click)="onDateSelect($event,date)"
              (pointerover)="highlightValue=date"
              (pointerout)="highlightValue=null"
            >
              <ng-container *ngIf="!dateTemplate">{{date.day}}</ng-container>
              <ng-container
                *ngTemplateOutlet="dateTemplate; context: {$implicit: date}"
              ></ng-container>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="interface-control__bfx-calendar__footer" style="visibility: hidden">
    <bfx-time-input
      *ngIf="!showSeconds"
      #inputTimeField
      [(ngModel)]="data.timeInputModel"
      [ngClass]="{'interface-control__bfx-calendar__time__input': true,
                            'interface-control__bfx-calendar__time__input-state--valid': data.state === 0,
                            'interface-control__bfx-calendar__time__input-state--invalid': data.state === 1,
                            'interface-control__bfx-calendar__time__input-state--active': data.state === 2}"
      (focus)="onTimeInputFocus($event)"
      (blur)="onTimeInputBlur($event)"
    >
    </bfx-time-input>
    <bfx-time-input
      *ngIf="showSeconds"
      #inputTimeField
      [(ngModel)]="data.timeInputModel"
      [ngClass]="{'interface-control__bfx-calendar__time__input': true,
                            'interface-control__bfx-calendar__time__input-state--valid': data.state === 0,
                            'interface-control__bfx-calendar__time__input-state--invalid': data.state === 1,
                            'interface-control__bfx-calendar__time__input-state--active': data.state === 2}"
      (focus)="onTimeInputFocus($event)"
      (blur)="onTimeInputBlur($event)"
    >
    </bfx-time-input>
    <button type="button" class="bfx-button-positive" (click)="onSaveClick()">Save</button>
    <button type="button" class="bfx-button-secondary-subtle" (click)="onCancelClick()">
      Cancel
    </button>
  </div>
  <div class="bfx-timepicker bfx-widget-header bfx-corner-all" *ngIf="showTime || timeOnly">
    <div class="bfx-hour-picker">
      <a href="#" (click)="incrementHour($event)">
        <span class="fa icon_ion_chevron_up"></span>
      </a>
      <span [ngStyle]="{'display': currentHour < 10 ? 'inline': 'none'}">0</span
      ><span>{{currentHour}}</span>
      <a href="#" (click)="decrementHour($event)">
        <span class="fa icon_ion_chevron_down"></span>
      </a>
    </div>
    <div class="bfx-separator">
      <a href="#">
        <span class="fa icon_ion_chevron_up"></span>
      </a>
      <span>:</span>
      <a href="#">
        <span class="fa icon_ion_chevron_down"></span>
      </a>
    </div>
    <div class="bfx-minute-picker">
      <a href="#" (click)="incrementMinute($event)">
        <span class="fa icon_ion_chevron_up"></span>
      </a>
      <span [ngStyle]="{'display': currentMinute < 10 ? 'inline': 'none'}">0</span
      ><span>{{currentMinute}}</span>
      <a href="#" (click)="decrementMinute($event)">
        <span class="fa icon_ion_chevron_down"></span>
      </a>
    </div>
    <div class="bfx-separator" *ngIf="showSeconds">
      <a href="#">
        <span class="fa icon_ion_chevron_up"></span>
      </a>
      <span>:</span>
      <a href="#">
        <span class="fa icon_ion_chevron_down"></span>
      </a>
    </div>
    <div class="bfx-second-picker" *ngIf="showSeconds">
      <a href="#" (click)="incrementSecond($event)">
        <span class="fa icon_ion_chevron_up"></span>
      </a>
      <span [ngStyle]="{'display': currentSecond < 10 ? 'inline': 'none'}">0</span
      ><span>{{currentSecond}}</span>
      <a href="#" (click)="decrementSecond($event)">
        <span class="fa icon_ion_chevron_down"></span>
      </a>
    </div>
    <div class="bfx-ampm-picker" *ngIf="hourFormat=='12'">
      <a href="#" (click)="toggleAMPM($event)">
        <span class="fa icon_ion_chevron_up"></span>
      </a>
      <span>{{pm ? 'PM' : 'AM'}}</span>
      <a href="#" (click)="toggleAMPM($event)">
        <span class="fa icon_ion_chevron_down"></span>
      </a>
    </div>
  </div>
  <div class="bfx-datepicker-buttonbar bfx-widget-header" *ngIf="showButtonBar">
    <div class="bfx-g">
      <div class="bfx-g-6">
        <button
          type="button"
          [label]="_locale.today"
          (click)="onTodayButtonClick($event)"
          pButton
          [ngClass]="[todayButtonStyleClass]"
        ></button>
      </div>
      <div class="bfx-g-6">
        <button
          type="button"
          [label]="_locale.clear"
          (click)="onClearButtonClick($event)"
          pButton
          [ngClass]="[clearButtonStyleClass]"
        ></button>
      </div>
    </div>
  </div>
  <ng-content select="p-footer"></ng-content>
</div>
